import {Injectable} from "@angular/core";
import {ObservableBackendService} from "./observableBackend.service";
import {InfractionType} from "../domain/infractionType";
import {Observable} from "rxjs/Rx";

/**
 * .
 * Created by jlado on 1/9/16.
 */
@Injectable()
export class InfractionTypeService {

    constructor(private backendService:ObservableBackendService) {
    }

    public getInfractionTypes():Observable<InfractionType[]> {
        return this.backendService.get("infractionTypes", null);
    }

    public getInfractionType(infractionTypeId:string):Observable<InfractionType> {
        return this.backendService.get("infractionType/" + infractionTypeId, null);
    }

    public saveAll(infractionType:InfractionType[]):Observable<InfractionType[]> {
        return this.backendService.post("infractionTypes", infractionType, null);
    }

    public save(infractionType:InfractionType):Observable<InfractionType> {
        if (infractionType.id != null) {
            return this.backendService.post("infractionType", infractionType, null);
        } else {
            return this.backendService.put("infractionType", infractionType, null);
        }
    }

    public delete(infractionTypeId:string):Observable<InfractionType> {
        return this.backendService.delete("infractionType/" + infractionTypeId, null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/infractionType.service.ts
 **/